module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.c82ed48e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLight.svg
// module id = 319
// module chunks = 3